import React, { useEffect, useRef, useState } from 'react';
import logo from '../assets/mockup2.png';

function Hero() {
    const heroRef = useRef(null);
    const btnRef = useRef(null);
    const [hidden, setHidden] = useState(false);

    // Detecta scroll para ocultar Hero
    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            setHidden(offset > window.innerHeight / 2);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Animación radial que sigue el mouse
    const handleMouseMove = (e) => {
        const rect = btnRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        btnRef.current.style.setProperty('--x', `${x}px`);
        btnRef.current.style.setProperty('--y', `${y}px`);
    };

    return (
        <section
            id="home"
            className={`hero-section py-5 ${hidden ? 'hide-hero' : ''}`}
            ref={heroRef}
        >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6" data-aos="fade-right">
                        <h1 className="display-4 fw-bold" style={{ color: 'var(--primary-color)' }}>
                            Comparte tu viaje universitario con <span style={{ color: 'var(--secondary-color)' }}>seguridad</span> y <span style={{ color: 'var(--secondary-color)' }}>comodidad</span>
                        </h1>
                        <p className="lead mt-3 text-muted">
                            EduDrive es la forma más segura, económica y práctica para llegar a tu universidad.
                            Más barato que un taxi, más cómodo que el transporte público.
                        </p>
                        <div
                            ref={btnRef}
                            className="gradient-btn mt-4"
                            onMouseMove={handleMouseMove}
                            onClick={() => window.location.href = '#download'}
                        >
                            <span>Mira como funciona</span>
                        </div>
                    </div>

                    <div className="circle-container d-none d-md-block">
                        <div className="circle-frame">
                            <img src={logo} alt="Logo EduDrive" className="logo-inside" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
